import * as React from "react";
import * as $ from "jquery";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../react-core/Html/TextBoxEditor";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { Objects } from "../../../../../react-core/Utils/Objects";
import { RegulatoryCheckInfoResult } from "../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoResult";
import { RegulatoryCheckInfoStatus } from "../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoStatus";
import { RegulatoryCheckInfoType } from "../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoType";
import { RegulatoryCheckDetailsModel } from "../../../../../Wrap/Models/Models/Customer/RegulatoryCheckDetailsModel";
import { ClientRecordAction } from "./Action/ClientRecordAction";
import { DataRetention } from "./Components/RegulatoryChecks/DataRetention";
import { SectionTable } from "./Components/SectionTable";
import {
    ClientRecordTab,
    IClientTabProps,
    RegulatoryCheckInfoTypeMap,
    RegulatoryCheckResultTypeMap,
    RegulatoryCheckTypeMap,
} from "./Resource/Contents";
import { NoteDetailModel } from "../../../../../Wrap/Models/Models/Customer/NoteDetailModel";
import { NoteType } from "../../../../../Wrap/Constants/Enums/Customer/NoteType";
import { CheckboxEditor } from "../../../../../react-core/Html/CheckboxEditor";
import { AMLCheck } from "./Components/AMLCheck";
import { CustomerType } from "../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { Organisation } from "../../../../../Wrap/Models/Models/Customer/Organisation";
import { ClientRecordStore } from "./Store/Variable";
import { SectionHeader } from "../Common/SharedComponents";
import { AddNewButton } from "./Components/AddNewButton";
import { ImportantFile } from "./Components/ImportantFile";
import { Lightbox } from "../../../../../react-core/Html/Components/Lightbox";
import { AMLCheckACtion } from "./Action/AMLCheckAction";

interface IRegulatoryCheckState {
    Data: Array<RegulatoryCheckDetailsModel>;
    noteData: Array<NoteDetailModel>;
    isLoading: boolean;
    isNoteLoading: boolean;
    dataRententionData: any;
    customerType: CustomerType;
    noteLightBox: boolean;
    isEdit: boolean;
    isHighRiskCustomer: boolean;
    originalHighRiskCustomer: boolean;
}
export class RegulatoryChecks extends FormComponent<IClientTabProps, IRegulatoryCheckState> {
    constructor(props: IClientTabProps) {
        super(props);
        this.state = {
            Data: [],
            noteData: null,
            isLoading: true,
            isNoteLoading: false,
            dataRententionData: {
                RetentionDate: null,
                Reason: " ",
                RequestDeletion: null,
                IsDisposalHold: false,
            },
            customerType: null,
            noteLightBox: false,
            isEdit: false,
            isHighRiskCustomer: null,
            originalHighRiskCustomer: null,
        };
        this.subscribeToStore(ClientRecordStore, () => this.onStoreChange());
    }
    private onStoreChange() {
        const data = ClientRecordStore.getData();
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.PersonalDetail])) {
            this.setState({ customerType: CustomerType.Individual });
        }
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.OrganisationDetails])) {
            const organisation: Organisation = data[ClientRecordTab.OrganisationDetails];
            this.setState({ customerType: organisation.CustomerType });
        }
    }

    private lightboxRef = null;

    componentDidMount() {
        ClientRecordAction.getCustomerRegulatoryCheckDetails(Number.parseInt(this.props.id), (val) => {
            this.setState({
                Data: val,
                isLoading: false,
            });
            this.getHRCData(val);
        });

        ClientRecordAction.getCustomerNoteDetails(Number.parseInt(this.props.id), (val) => {
            const regNote = val.filter(
                (x) => x.NoteType == NoteType.RegulatoryCheck || x.NoteType == NoteType.RegulatoryCritical
            );
            this.setState({
                noteData: this.orderNotesList(regNote),
                isNoteLoading: false,
            });
        });
        ClientRecordAction.getPersonalDetail(this.props.id);
        ClientRecordAction.getOrganisationDetail(this.props.id);
    }

    public render(): JSX.Element {
        const { isHighRiskCustomer, isEdit, originalHighRiskCustomer } = this.state;
        if (this.state.isLoading || this.state.isNoteLoading) {
            return <PartLoading isLoading={true} />;
        }
        const aml = this.state.Data.filter((x) => x.RegulatoryCheckType == RegulatoryCheckInfoType.AML);
        const pep = this.state.Data.filter((x) => x.RegulatoryCheckType == RegulatoryCheckInfoType.PEP);
        const fs = this.state.Data.filter((x) => x.RegulatoryCheckType == RegulatoryCheckInfoType.FinancialSanction);
        const hrc = this.state.Data.filter((x) => x.RegulatoryCheckType == RegulatoryCheckInfoType.HighRiskCustomer);

        return (
            <div className="panel-subtle pl-34 pt-38">
                {this.renderSection(aml, RegulatoryCheckInfoType.AML)}
                <hr className="mb-32 mt-20" />
                {this.renderSection(pep, RegulatoryCheckInfoType.PEP)}
                <hr className="mb-32 mt-20" />
                {this.renderSection(fs, RegulatoryCheckInfoType.FinancialSanction)}
                <hr className="mb-32 mt-20" />

                <h3 className="pr-20">High Risk Customer</h3>
                {!this.state.isEdit && (
                    <dl className="def-list">
                        <dt>
                            <div className="row-auto">High Risk Customer</div>
                        </dt>
                        <dd>
                            <div className="row-auto">
                                {hrc == null || hrc?.length == 0 || this.state.isHighRiskCustomer == null
                                    ? "No"
                                    : this.state.isHighRiskCustomer == true
                                    ? "Yes"
                                    : "No"}
                            </div>
                        </dd>
                    </dl>
                )}
                {this.state.isEdit && (
                    <CheckboxEditor
                        label="High Risk Customer"
                        cssWrapper="square-checkbox block mt-19"
                        value={this.state.isHighRiskCustomer}
                        onChange={(v) => this.setState({ isHighRiskCustomer: v })}
                        disabled={!this.state.isEdit}
                    />
                )}

                <div>
                    <div className="row row-center">
                        {this.props.hasReadWriteAccess && !this.state.isEdit && (
                            <div className="col-auto">
                                <button
                                    className="edit-circle-icon-button label-sr-only"
                                    title="Edit"
                                    onClick={() => this.setState({ isEdit: true })}
                                >
                                    <span className="icon" aria-hidden="true"></span>
                                    <span className="text">Edit</span>
                                </button>
                            </div>
                        )}
                        {this.state.isEdit && (
                            <div className="col-auto">
                                <button
                                    className="button mr-20"
                                    onClick={(val) =>
                                        this.setState({
                                            isEdit: false,
                                            isHighRiskCustomer: this.state.originalHighRiskCustomer,
                                        })
                                    }
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                        {this.state.isEdit && (
                            <div className="col-auto">
                                <button className="button" onClick={(val) => this.saveSetting(hrc)}>
                                    Save
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                {this.renderHRCM(hrc, RegulatoryCheckInfoType.HighRiskCustomer)}
                <hr className="mb-32 mt-20" />

                {this.renderNote(this.state.noteData)}
                {/* Hiding data retention section as backend hasn't been implemented */}
                {/* <hr className="mb-32 mt-20" />
                <DataRetention
                    data={this.state.dataRententionData}
                    onChange={(data) => {
                        this.UpdateDataRetentionValues(data);
                    }}
                /> */}
                {this.state.noteLightBox && (
                    <Lightbox
                        onClose={() => {
                            this.setState({ noteLightBox: false });
                        }}
                        cssWrapper="is-default-lightbox"
                        show={this.state.noteLightBox}
                        title={"Error"}
                    >
                        <p>A customer can has up to 50 important notes.</p>
                        <div className="row">
                            <div className="col-auto">
                                <button
                                    className="btn secondary"
                                    onClick={() => {
                                        this.setState({ noteLightBox: false });
                                    }}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </Lightbox>
                )}
            </div>
        );
    }

    private saveSetting(regChecks: Array<RegulatoryCheckDetailsModel>) {
        const Data = this.state.Data;
        const data = regChecks[0];

        this.setState({ isEdit: false, originalHighRiskCustomer: this.state.isHighRiskCustomer });
        if (regChecks == null || regChecks?.length == 0) {
            const hrcData: RegulatoryCheckDetailsModel = {
                RegulatoryCheckType: RegulatoryCheckInfoType.HighRiskCustomer,

                RegulatoryCheckStatus: RegulatoryCheckInfoStatus.Vetted,

                RegulatoryCheckResult: this.state.isHighRiskCustomer
                    ? RegulatoryCheckInfoResult.HighRisk
                    : RegulatoryCheckInfoResult.NotHighRisk,
            };
            ClientRecordAction.addCustomerRegulatoryCheckDetails(
                Number.parseInt(this.props.id),
                hrcData,
                RegulatoryCheckInfoType.HighRiskCustomer,
                (val) => {
                    ClientRecordAction.getCustomerRegulatoryCheckDetails(Number.parseInt(this.props.id), (val) => {
                        this.setState({
                            Data: val,
                            isLoading: false,
                        });
                        this.getHRCData(val);
                    });
                }
            );
        } else {
            const index = Data.findIndex((ele) => ele.RegulatoryCheckType == RegulatoryCheckInfoType.HighRiskCustomer);
            data.CheckDateTime = null;
            data.RegulatoryCheckResult = this.state.isHighRiskCustomer
                ? RegulatoryCheckInfoResult.HighRisk
                : RegulatoryCheckInfoResult.NotHighRisk;
            Data[index] = data;
            ClientRecordAction.saveCustomerRegulatoryCheckDetails(
                Number.parseInt(this.props.id),
                Data,
                RegulatoryCheckInfoType.HighRiskCustomer,
                (val) => {
                    ClientRecordAction.getCustomerRegulatoryCheckDetails(Number.parseInt(this.props.id), (val) => {
                        this.setState({
                            Data: val,
                            isLoading: false,
                        });
                        this.getHRCData(val);
                    });
                }
            );
        }
    }

    private renderHRCM(regChecks: Array<RegulatoryCheckDetailsModel>, type: RegulatoryCheckInfoType): JSX.Element {
        if (regChecks == null || regChecks?.length == 0) {
            return (
                <dl className="mb-0 def-list wider">
                    <div>
                        <dt>
                            <div className="row-auto">High Risk Customer last modified</div>
                        </dt>
                        <dt>
                            <div className="row-auto">High Risk Customer last modified by</div>
                        </dt>
                    </div>
                </dl>
            );
        } else {
            return (
                <dl className="mb-0 def-list wider">
                    <div>
                        <dt>
                            <div className="row-auto">
                                High Risk Customer last modified
                                <dt>
                                    {JsonDateParser.getFormatDate(regChecks[0].CheckDateTime, "dd-MM-yyyy hh:mm:ss")}
                                </dt>
                            </div>
                        </dt>
                        <dt>
                            <div className="row-auto">
                                High Risk Customer last modified by
                                <dt>{regChecks[0].LastModifiedBy}</dt>
                            </div>
                        </dt>
                    </div>
                </dl>
            );
        }
    }

    private getHRCData(val: Array<RegulatoryCheckDetailsModel>) {
        const hrc = val.filter((x) => x.RegulatoryCheckType == RegulatoryCheckInfoType.HighRiskCustomer);
        if (hrc != null && hrc[0]?.RegulatoryCheckResult == RegulatoryCheckInfoResult.HighRisk) {
            this.setState({
                isHighRiskCustomer: true,
                originalHighRiskCustomer: true,
            });
        } else if (hrc == null || hrc[0]?.RegulatoryCheckResult == RegulatoryCheckInfoResult.NotHighRisk) {
            this.setState({
                isHighRiskCustomer: false,
                originalHighRiskCustomer: false,
            });
        }
    }

    private renderNote(note: Array<NoteDetailModel>): JSX.Element {
        return (
            <ImportantFile
                data={note}
                onAdd={(data) => this.onNoteAdd(data, note)}
                onSave={(data) => this.onNoteSave(data)}
                onDelete={(data) => this.onNoteDelete(data)}
                hasReadWriteAccess={this.props?.hasReadWriteAccess}
            />
        );
    }

    private renderSection(regChecks: Array<RegulatoryCheckDetailsModel>, type: RegulatoryCheckInfoType): JSX.Element {
        const aml =
            this.state.customerType == CustomerType.Individual && type == RegulatoryCheckInfoType.AML ? (
                <AMLCheck
                    customerId={Number.parseInt(this.props.id)}
                    onSuccess={() => {
                        ClientRecordAction.getCustomerRegulatoryCheckDetails(Number.parseInt(this.props.id), (val) => {
                            this.setState({
                                Data: val,
                                isLoading: false,
                            });
                            this.lightboxRef(false);
                        });
                    }}
                />
            ) : null;

        if (regChecks == null || regChecks?.length == 0) {
            return (
                <>
                    <SectionTable
                        sectionHeader={RegulatoryCheckTypeMap[type]}
                        columnConfigs={this.getColumnConfig(null, RegulatoryCheckTypeMap[type])}
                        lightboxContent={(data, onDataChange) =>
                            this.renderLightBox(data, onDataChange, RegulatoryCheckTypeMap[type])
                        }
                        key={RegulatoryCheckTypeMap[type]}
                        onSave={(data) => this.onAdd(data)}
                        data={{ RegulatoryCheckType: type }}
                        onRef={(ref) => {
                            if (type == RegulatoryCheckInfoType.AML) {this.lightboxRef = ref;}
                        }}
                        extraButton={aml}
                        canEdit={this.props?.hasReadWriteAccess == true}
                    />
                </>
            );
        } else {
            return (
                <>
                    <SectionTable
                        sectionHeader={RegulatoryCheckTypeMap[type]}
                        columnConfigs={this.getColumnConfig(regChecks[0], RegulatoryCheckTypeMap[type])}
                        lightboxContent={(data, onDataChange) =>
                            this.renderLightBox(data, onDataChange, RegulatoryCheckTypeMap[type])
                        }
                        key={RegulatoryCheckTypeMap[type]}
                        onSave={(data) => this.onSave(data)}
                        data={regChecks[0]}
                        onRef={(ref) => {
                            this.lightboxRef = ref;
                        }}
                        extraButton={aml}
                        canEdit={this.props?.hasReadWriteAccess == true}
                    />
                </>
            );
        }
    }

    private getColumnConfig(ele: RegulatoryCheckDetailsModel, type: string): Array<any> {
        const result = [];
        if (type == "AML") {
            result.push({
                title: "AML method",
                data: ele == null ? " " : ele.ServiceProvider,
            });
        }
        result.push({
            title: `${type} check status`,
            data:
                ele == null || ele.RegulatoryCheckStatus == null
                    ? " "
                    : RegulatoryCheckInfoTypeMap[ele.RegulatoryCheckStatus],
        });
        result.push({
            title: `${type} status`,
            data:
                ele == null || ele.RegulatoryCheckResult == null
                    ? " "
                    : ele.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.NotVetted ||
                      ele.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.SelfCertified
                    ? "N/A"
                    : RegulatoryCheckResultTypeMap[ele.RegulatoryCheckResult],
        });

        result.push({
            title: `${type} last modified`,
            data:
                ele == null || ele.CheckDateTime == null
                    ? " "
                    : JsonDateParser.getFormatDate(ele.CheckDateTime, "dd-MM-yyyy hh:mm:ss"),
        });
        result.push({
            title: `${type} last modified by`,
            data: ele == null || CommonHelper.isNullOrEmpty(ele.LastModifiedBy) ? " " : ele.LastModifiedBy,
        });
        if (type == "AML") {
            result.push({
                title: `3rd party AML identifier`,
                data:
                    ele == null || CommonHelper.isNullOrEmpty(ele.ExternalIdentifier) ? (
                        " "
                    ) : (
                        <div style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
                            <p>{ele.ExternalIdentifier}</p>
                        </div>
                    ),
            });
        }
        return result;
    }

    private onSave(data): boolean {
        if (this.isValid()) {
            const type = data.RegulatoryCheckType;
            const { Data } = this.state;
            const index = Data.findIndex((ele) => ele.RegulatoryCheckType == type);
            data.CheckDateTime = null;
            if (data.RegulatoryCheckResult == null) {
                switch (data.RegulatoryCheckType) {
                    case RegulatoryCheckInfoType.AML:
                        data.RegulatoryCheckResult = RegulatoryCheckInfoResult.Fail;
                        break;
                    case RegulatoryCheckInfoType.PEP:
                        data.RegulatoryCheckResult = RegulatoryCheckInfoResult.Pep;
                        break;
                    case RegulatoryCheckInfoType.FinancialSanction:
                        data.RegulatoryCheckResult = RegulatoryCheckInfoResult.NonSanction;
                        break;
                }
            }
            Data[index] = data;
            ClientRecordAction.saveCustomerRegulatoryCheckDetails(
                Number.parseInt(this.props.id),
                Data,
                data.RegulatoryCheckType,
                (val) => {
                    ClientRecordAction.getCustomerRegulatoryCheckDetails(Number.parseInt(this.props.id), (val) => {
                        this.setState({
                            Data: val,
                            isLoading: false,
                        });
                    });
                }
            );

            return true;
        }
        return false;
    }

    private UpdateDataRetentionValues(updatedData: any) {
        const existingModel = Objects.cloneObject(this.state.dataRententionData);
        const updatedValue = $.extend(true, existingModel, updatedData);
        this.setState({ dataRententionData: updatedValue });
    }

    private onAdd(data): boolean {
        if (this.isValid()) {
            const Data = this.state.Data;
            data.CheckDateTime = null;
            if (data.RegulatoryCheckResult == null) {
                switch (data.RegulatoryCheckType) {
                    case RegulatoryCheckInfoType.AML:
                        data.RegulatoryCheckResult = RegulatoryCheckInfoResult.Fail;
                        break;
                    case RegulatoryCheckInfoType.PEP:
                        data.RegulatoryCheckResult = RegulatoryCheckInfoResult.Pep;
                        break;
                    case RegulatoryCheckInfoType.FinancialSanction:
                        data.RegulatoryCheckResult = RegulatoryCheckInfoResult.NonSanction;
                        break;
                }
            }

            Data.push(data);
            ClientRecordAction.addCustomerRegulatoryCheckDetails(
                Number.parseInt(this.props.id),
                data,
                data.RegulatoryCheckType,
                (val) => {
                    ClientRecordAction.getCustomerRegulatoryCheckDetails(Number.parseInt(this.props.id), (val) => {
                        this.setState({
                            Data: val,
                            isLoading: false,
                        });
                    });
                }
            );

            return true;
        }
        return false;
    }

    private onNoteAdd(data, note: Array<NoteDetailModel>): boolean {
        if (note.length >= 50) {
            this.setState({ noteLightBox: true });
            return true;
        }

        if (this.isValid()) {
            ClientRecordAction.addCustomerNoteDetails(Number.parseInt(this.props.id), data, (val) => {
                ClientRecordAction.getCustomerNoteDetails(Number.parseInt(this.props.id), (val) => {
                    const regNote = val.filter(
                        (x) => x.NoteType == NoteType.RegulatoryCheck || x.NoteType == NoteType.RegulatoryCritical
                    );
                    this.setState({
                        noteData: this.orderNotesList(regNote),
                        isNoteLoading: false,
                    });
                });
            });

            return true;
        }
        return false;
    }
    private onNoteSave(data): boolean {
        if (this.isValid()) {
            ClientRecordAction.saveCustomerNoteDetails(Number.parseInt(this.props.id), data, (val) => {
                ClientRecordAction.getCustomerNoteDetails(Number.parseInt(this.props.id), (val) => {
                    const regNote = val.filter(
                        (x) => x.NoteType == NoteType.RegulatoryCheck || x.NoteType == NoteType.RegulatoryCritical
                    );
                    this.setState({
                        noteData: this.orderNotesList(regNote),
                        isNoteLoading: false,
                    });
                });
            });

            return true;
        }
        return false;
    }

    private onNoteDelete(data): boolean {
        if (this.isValid()) {
            ClientRecordAction.deleteCustomerNoteDetails(Number.parseInt(this.props.id), data, (val) => {
                ClientRecordAction.getCustomerNoteDetails(Number.parseInt(this.props.id), (val) => {
                    const regNote = val.filter(
                        (x) => x.NoteType == NoteType.RegulatoryCheck || x.NoteType == NoteType.RegulatoryCritical
                    );
                    this.setState({
                        noteData: this.orderNotesList(regNote),
                        isNoteLoading: false,
                    });
                });
            });

            return true;
        }
        return false;
    }

    private orderNotesList(notes: Array<NoteDetailModel>): Array<NoteDetailModel> {
        // filter out critial type
        const criticalList = notes.filter((e) => e?.NoteType == NoteType.RegulatoryCritical);
        // order by create date desc
        const _sortedCriticalList = criticalList.sort((a, b) => {
            if (JsonDateParser.toDate(a?.ModifiedTime) > JsonDateParser.toDate(b?.ModifiedTime)) {
                return -1;
            }
            if (JsonDateParser.toDate(a?.ModifiedTime) < JsonDateParser.toDate(b?.ModifiedTime)) {
                return 1;
            }
            return 0;
        });

        // filter out normal list
        const normalList = notes.filter((e) => e?.NoteType == NoteType.RegulatoryCheck);
        // order by create date desc
        const _sortedNormalList = normalList.sort((a, b) => {
            if (JsonDateParser.toDate(a?.ModifiedTime) > JsonDateParser.toDate(b?.ModifiedTime)) {
                return -1;
            }
            if (JsonDateParser.toDate(a?.ModifiedTime) < JsonDateParser.toDate(b?.ModifiedTime)) {
                return 1;
            }
            return 0;
        });

        const result = _sortedCriticalList.concat(_sortedNormalList);
        return result;
    }

    private getStatusByType(type: string): any[] {
        switch (type) {
            case "AML":
                return [
                    RegulatoryCheckInfoResult.Pass,
                    RegulatoryCheckInfoResult.Fail,
                    RegulatoryCheckInfoResult.Refer,
                ];
            case "PEP":
                return [
                    RegulatoryCheckInfoResult.NonPep,
                    RegulatoryCheckInfoResult.Pep,
                    RegulatoryCheckInfoResult.HighRiskPep,
                    RegulatoryCheckInfoResult.UnconfirmedPep,
                ];
            case "Subject to Sanctions":
                return [
                    RegulatoryCheckInfoResult.NonSanction,
                    RegulatoryCheckInfoResult.Sanction,
                    RegulatoryCheckInfoResult.UnconfirmedSanction,
                ];
            default:
                return [];
        }
    }

    private renderLightBoxForNote(ele: NoteDetailModel, onDataChange): JSX.Element {
        return (
            <>
                <CheckboxEditor
                    value={ele?.Note != null}
                    cssWrapper="control-size-60 square-checkbox"
                    label={"Important File Note"}
                    onChange={(v) => {
                        onDataChange({ Note: v ? "" : null, NoteType: NoteType.RegulatoryCheck });
                    }}
                />
                {ele?.Note != null && (
                    <TextBoxEditor
                        value={ele?.Note}
                        label={"Note"}
                        cssWrapper="control-size-430"
                        maxLength={250}
                        required={ele?.Note != null ? "Please enter" : null}
                        onChange={(v) => {
                            onDataChange({ Note: v });
                        }}
                    />
                )}
                <p>
                    Important File Note last modified
                    {JsonDateParser.getFormatDate(ele?.ModifiedTime, "dd-MM-yyyy hh:mm:ss")}
                </p>
                <p>Important File Note last modified by {ele?.LastModifiedBy}</p>
            </>
        );
    }
    private renderLightBox(ele: RegulatoryCheckDetailsModel, onDataChange, header: string): JSX.Element {
        return (
            <>
                {header == "AML" && (
                    <SelectEditor
                        options={["Manual", "Experian"]}
                        getText={(v) => {
                            return v;
                        }}
                        placeholder="Please select"
                        label={"AML method"}
                        required={CommonHelper.isNullOrEmpty(ele?.ServiceProvider) ? "Please select AML method" : null}
                        selected={
                            ele?.ServiceProvider &&
                            (ele?.ServiceProvider == "Manual" || ele?.ServiceProvider == "Experian")
                                ? ele?.ServiceProvider
                                : null
                        }
                        cssWrapper="control-size-430"
                        onChange={(v) => {
                            onDataChange({ ServiceProvider: v });
                        }}
                    />
                )}
                {header == "AML" &&
                    !CommonHelper.isNullOrEmpty(ele?.ServiceProvider) &&
                    ele?.ServiceProvider != "Manual" &&
                    ele?.ServiceProvider != "Experian" && <span>AML method : {ele?.ServiceProvider}</span>}

                <SelectEditor
                    options={Object.keys(RegulatoryCheckInfoTypeMap).map((e) => Number(e))}
                    getText={(v) => {
                        return RegulatoryCheckInfoTypeMap[v];
                    }}
                    placeholder="Please select"
                    label={`${header} check status`}
                    required={`Please select ${header} check status`}
                    selected={ele?.RegulatoryCheckStatus}
                    cssWrapper="control-size-430"
                    onChange={(v) => {
                        let isChangeToVetted = false;
                        if (
                            (ele.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.NotVetted ||
                                ele.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.SelfCertified) &&
                            v == RegulatoryCheckInfoStatus.Vetted
                        ) {
                            isChangeToVetted = true;
                        }
                        onDataChange({
                            RegulatoryCheckStatus: v,
                            RegulatoryCheckResult:
                                isChangeToVetted ||
                                v == RegulatoryCheckInfoStatus.NotVetted ||
                                v == RegulatoryCheckInfoStatus.SelfCertified
                                    ? null
                                    : ele?.RegulatoryCheckResult,
                        });
                    }}
                />

                <SelectEditor
                    options={this.getStatusByType(header)}
                    getText={(v) => {
                        return RegulatoryCheckResultTypeMap[v];
                    }}
                    placeholder={
                        ele?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.NotVetted ||
                        ele?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.SelfCertified
                            ? "N/A"
                            : "Please select"
                    }
                    label={`${header} status`}
                    disabled={
                        ele?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.NotVetted ||
                        ele?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.SelfCertified
                            ? true
                            : false
                    }
                    required={
                        ele?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.NotVetted ||
                        ele?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.SelfCertified
                            ? null
                            : `Please select ${header} status`
                    }
                    selected={
                        ele?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.NotVetted ||
                        ele?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.SelfCertified
                            ? null
                            : ele?.RegulatoryCheckResult
                    }
                    cssWrapper="control-size-430"
                    onChange={(v) => {
                        onDataChange({ RegulatoryCheckResult: v });
                    }}
                />

                <p>
                    {header} last modified {JsonDateParser.getFormatDate(ele?.CheckDateTime, "dd-MM-yyyy hh:mm:ss")}
                </p>
                <p>
                    {header} last modified by {ele?.LastModifiedBy}
                </p>
                {header == "AML" && (
                    <TextBoxEditor
                        value={ele?.ExternalIdentifier}
                        label={"3rd party AML identifier"}
                        cssWrapper="control-size-430"
                        maxLength={100}
                        onChange={(v) => {
                            onDataChange({ ExternalIdentifier: v });
                        }}
                    />
                )}
            </>
        );
    }
}
